import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

const PlayPauseIcon = ({ isPlaying, className = '' }) => {
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')
  const bg = isHalloween ? 'rgba(237, 113, 43, 1)' : '#8B4AF2'

  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <rect width='40' height='40' rx='8' fill={bg} />
      <rect x='0.625' y='0.625' width='38.75' height='38.75' rx='7.375' stroke='white' strokeWidth='1.25' />
      {isPlaying ? (
        <>
          <rect x='13' y='11' width='4' height='18' rx='2' fill='white' />
          <rect x='23' y='11' width='4' height='18' rx='2' fill='white' />
        </>
      ) : (
        <path d='M16 11L28 20L16 29V11Z' fill='white' />
      )}
    </svg>
  )
}

PlayPauseIcon.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default PlayPauseIcon
